import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 15 * 60;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return <div className="flex items-center justify-center gap-1.5 rounded-md bg-brand-red px-2.5 py-1.5 text-white" role="timer" aria-live="off" data-id="element-31" data-mp="3h1qr3mmgkcdu">
      <span className="font-heading text-[10px] font-extrabold uppercase tracking-wide sm:text-[11px]" data-id="element-32" data-mp="372jgv8b0sxuy">
        ⏳ L’offerta termina tra
      </span>
      <span className="font-heading text-sm font-extrabold tabular-nums sm:text-base" data-id="element-33" data-mp="10cv3ocyeonis">
        {pad(minutes)}:{pad(seconds)}
      </span>
    </div>;
}